<app-funnel-shell>
  <div class="funnel-card funnel-checkout">
    <h1>{{ 'funnel.checkout.title' | translate }}</h1>

    @if (loading()) {
      <p class="funnel-card__intro">{{ 'funnel.checkout.loading' | translate }}</p>
    }

    @if (resultKey(); as key) {
      <div class="funnel-checkout__summary">
        <div class="funnel-checkout__summary-label">{{ 'funnel.checkout.you_chose' | translate }}</div>
        <div class="funnel-checkout__summary-name">{{ key + '.title' | translate }}</div>
        <div class="funnel-checkout__summary-price">${{ product()?.price }}</div>
        <!-- The price above is what this checkout charges. A card also carries an
             activation fee that is paid to the card partner in the card dashboard,
             so it has to be named here rather than first appearing on the invoice. -->
        @if (product()?.activation_fee) {
          <div class="funnel-checkout__summary-note">
            {{ 'funnel.activation_fee_note' | translate: { fee: '$' + product()?.activation_fee } }}
          </div>
          <!-- One-time payment, not a term: the expiry date printed on the card
               raised the question, so it is answered right before the purchase. -->
          <div class="funnel-checkout__summary-note">
            {{ 'funnel.one_time_payment_note' | translate: { price: '$' + product()?.total_customer_price } }}
          </div>
        }
      </div>

      <h2 class="funnel-checkout__h2">{{ 'funnel.checkout.choose_method' | translate }}</h2>

      <div class="funnel-checkout__methods">
        @for (m of methods; track m.key) {
          <label
            class="funnel-checkout__method"
            [class.is-selected]="selected() === m.key && m.enabled"
            [class.is-disabled]="!m.enabled"
          >
            <input
              type="radio"
              name="payment_method"
              [value]="m.key"
              [checked]="selected() === m.key"
              [disabled]="!m.enabled"
              (change)="selectMethod(m.key, m.enabled)"
            />
            <div class="funnel-checkout__method-body">
              <div class="funnel-checkout__method-label">
                {{ m.i18n_label | translate }}
                @if (!m.enabled) {
                  <span class="funnel-checkout__badge">{{ 'funnel.checkout.coming_soon' | translate }}</span>
                }
              </div>
              <div class="funnel-checkout__method-hint">{{ m.i18n_hint | translate }}</div>
            </div>
          </label>
        }
      </div>

      <div class="funnel-checkout__actions">
        <button cButton color="link" type="button" (click)="onBack()">
          {{ 'funnel.checkout.back' | translate }}
        </button>
        <button cButton color="primary" type="button" [disabled]="busy()" (click)="onProceed()">
          @if (busy()) {
            {{ 'funnel.checkout.processing' | translate }}
          } @else {
            {{ 'funnel.checkout.proceed' | translate }}
          }
        </button>
      </div>
    }

    @if (error()) {
      <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
    }
  </div>
</app-funnel-shell>
